import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { getMyBizList } from '@/api/cmdb';
import store from '@/store/index';
export default {
  name: 'BizList',
  data: function data() {
    return {
      bizList: []
    };
  },
  computed: _objectSpread({}, mapGetters(['currBiz'])),
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var results;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMyBizList({
              system: 'agent'
            });
          case 2:
            results = _context.sent;
            this.bizList = results;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  beforeMount: function beforeMount() {
    this.getCurrBizName();
  },
  methods: {
    changeCurrBiz: function changeCurrBiz(value) {
      store.commit('profile/SET_CURR_BIZ', value);
      this.getCurrBizName();
      console.log(this.$router);
      this.$router.replace('/redirect' + this.$router.currentRoute.fullPath);
    },
    getCurrBizName: function getCurrBizName() {
      var _this = this;
      getMyBizList({
        system: 'agent'
      }).then(function (data) {
        var obj = {};
        var biz_id = _this.currBiz;
        obj = data.find(function (item) {
          return item.id === biz_id;
        });
        store.commit('profile/SET_CURR_BIZ_NAME', obj.name);
      });
    }
  }
};